// /sign-in-session — the explicit Continue step for a CLI / plugin sign-in
// link (server CORE-AUTH-TAKEOVER-PATHS D9). A device (smbls CLI, Figma
// plugin) starts a session and opens `/login?session=<id>`; the server no
// longer arms it for whoever opens the link. This step shows when and from
// where the sign-in was started and which client asks, asks for the code
// the device shows when the server requires it, and arms the session for
// the signed-in account only on Continue.

// Read the session facts once per page. Read only. `error` / `codeError`
// hold the full polyglot key of the message to show.
export const loadSignInSession = async function loadSignInSession() {
  const s = this.state
  if (s.requested) return
  s.update({ requested: true })
  const sessionId = new URLSearchParams(window.location.search).get('session') || ''
  if (!sessionId) {
    s.update({ loading: false, error: 'workspace.signInSession.error.expired' })
    return
  }
  try {
    const info = await this.sdk.getSignInSessionInfo(sessionId)
    if (!info || info.status !== 'pending') {
      s.update({ loading: false, error: 'workspace.signInSession.error.expired' })
      return
    }
    s.update({
      loading: false,
      sessionId,
      createdAt: info.createdAt || '',
      requesterIp: info.requesterIp || '',
      client: info.client || '',
      codeRequired: !!info.codeRequired
    })
  } catch (error) {
    const status = error?.cause?.status
    s.update({
      loading: false,
      error:
        status === 404
          ? 'workspace.signInSession.error.expired'
          : 'workspace.signInSession.error.failed'
    })
  }
}

// The Continue click: arm the session for the signed-in account.
export const confirmSignInSession = async function confirmSignInSession() {
  const s = this.state
  if (s.submitting || !s.sessionId) return
  if (s.codeRequired && !String(s.code || '').trim()) {
    s.update({ codeError: 'workspace.signInSession.codeError.missing' })
    return
  }
  s.update({ submitting: true, codeError: null })
  try {
    await this.sdk.activateSignInSession(s.sessionId, s.codeRequired ? String(s.code).trim() : undefined)
    s.update({ submitting: false, done: true })
  } catch (error) {
    const status = error?.cause?.status
    if (status === 403) {
      s.update({ submitting: false, codeError: 'workspace.signInSession.codeError.wrong' })
      return
    }
    s.update({
      submitting: false,
      error:
        status === 410
          ? 'workspace.signInSession.error.locked'
          : status === 404 || status === 409
            ? 'workspace.signInSession.error.expired'
            : 'workspace.signInSession.error.failed'
    })
  }
}
